import { useState } from 'react';
import { HowToReg, Close } from '@mui/icons-material';
import { Button, FormControl, MenuItem, Select } from '@mui/material';
import useRoles from '../../Hooks/useRoles';
import { changeRole } from 'Api/employeeAsess';
import { useHistory } from 'react-router-dom';
import {
  ModalContainer,
  Header,
  Body,
  ButtonContainer,
  FloatingClose,
  acceptButton,
  cancelButton,
  titleStyle,
  iconStyle,
  IconContainer,
  hrStyle,
} from './style';

function ChangeUserRole({ t2, setOpen, id, oldRole }) {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const { roles } = useRoles(setLoading);
  const [selectedRole, setSelectedRole] = useState(oldRole);
  const [idRole, setIdRole] = useState('');

  const handleChange = e => {
    setSelectedRole(e.target.value);
  };

  const submitChange = async () => {
    if (idRole === '') {
      alert(t2('AlertNotNewRole'));
      return;
    }
    const response = await changeRole({ userId: id, roleId: idRole });
    if (response?.id) {
      setOpen(false);
      alert(t2('AlertSuccessChangeRole'));
      history.goBack();
      window.location.reload();
    }
  };

  return (
    <ModalContainer>
      <Header>
        <IconContainer>
          <HowToReg sx={{ width: 40, height: 40 }} style={iconStyle} />
        </IconContainer>
        <FloatingClose>
          <Close sx={{ width: 25, height: 25 }} onClick={() => setOpen(false)} />
        </FloatingClose>
      </Header>
      <Body>
        <div style={titleStyle}>{t2('ChangeRole')}</div>

        <FormControl fullWidth>
          <Select value={selectedRole} onChange={handleChange} placeholder={t2('ChangeRole')}>
            {loading ? (
              <MenuItem disabled>
                <em>Cargando roles...</em>
              </MenuItem>
            ) : (
              roles.map(role => (
                <MenuItem
                  key={role[1]}
                  value={role[0]}
                  onClick={() => setIdRole(role[1])}
                  disabled={role[0] === oldRole}
                >
                  {role[0]}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </Body>
      <>
        <hr style={hrStyle} />
        <ButtonContainer>
          <Button variant="outlined" style={cancelButton} onClick={() => setOpen(false)}>
            {t2('Cancel')}
          </Button>
          <Button variant="contained" style={acceptButton} onClick={submitChange}>
            {t2('Accept')}
          </Button>
        </ButtonContainer>
      </>
    </ModalContainer>
  );
}

export default ChangeUserRole;
